import {
  IDashboardState,
  IReportUsage,
} from './dashboard-redux.model';
import { DashboardActionType } from './dashboard-action-types';

export const initialDashboardState: IDashboardState = {
  loadingReportUsage: false,
  loadingReportTimeline: false,
  reportUsage: [],
  reportTimeline: [],
  loadingNpsScore: false,
  npsScore: null,
  loadingCareSourceNpsScore: false,
  careSourceNpsScore: null,
}

const dashboardReducer = (state: IDashboardState = initialDashboardState, action: any) => {
  switch (action.type) {
    case DashboardActionType.GetReportUsage:
      return {
        ...state,
        loadingReportUsage: true,
        reportUsage: []
      };

    case DashboardActionType.GetReportUsageSuccess:
      return {
        ...state,
        loadingReportUsage: false,
        reportUsage: action.payload.data || [],
      };

    case DashboardActionType.GetReportUsageFailure:
      return {
        ...state,
        loadingReportUsage: false,
        reportUsage: [],
      };

    case DashboardActionType.GetReportTimeline:
      return {
        ...state,
        loadingReportTimeline: true,
        reportTimeline: []
      };

    case DashboardActionType.GetReportTimelineSuccess:

      return {
        ...state,
        loadingReportTimeline: false,
        reportTimeline: action.payload.data || [],
      };

    case DashboardActionType.GetReportTimelineFailure:
      return {
        ...state,
        loadingReportTimeline: false,
        reportTimeline: [],
      };

    case DashboardActionType.GetNpsScore:
      return { ...state, loadingNpsScore: true, npsScore: null };

    case DashboardActionType.GetNpsScoreSuccess:
      return { ...state, loadingNpsScore: false, npsScore: action.payload };

    case DashboardActionType.GetNpsScoreFailure:
      return { ...state, loadingNpsScore: false, npsScore: null };

    case DashboardActionType.GetCareSourceNpsScore:
      return { ...state, loadingCareSourceNpsScore: true, careSourceNpsScore: null };

    case DashboardActionType.GetCareSourceNpsScoreSuccess:
      return { ...state, loadingCareSourceNpsScore: false, careSourceNpsScore: action.payload };

    case DashboardActionType.GetCareSourceNpsScoreFailure:
      return { ...state, loadingCareSourceNpsScore: false, careSourceNpsScore: null };

    default:
      return state
  }
}

export default dashboardReducer;